import {NavLink, useParams} from "react-router";

function VendorDetailHome(props) {

    const vendor = props.vendor;

    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: vendor.description }} />
        </>
    );
}

export default VendorDetailHome;
